const statusField = (isError: any, isTouched: any, isDirty: any, isValid: boolean) => {
  if (isError || (isTouched && isDirty)) {
    return "bc-input-error";
  } else if (isTouched && isValid) {
    return "bc-input-success";
  }
};

export { statusField };
